import { Route } from "@angular/router";

export const redirectRoutes: Route[] = [
  {
    path: "redirect",
    loadComponent: () => import("./components/redirect/redirect.component").then(c => c.RedirectComponent)
  }
];